<svelte:body on:item={put_item} />
<script>
    import _ from 'lodash';
    import {toastbox} from '../../../utils.js';
    import {validate_int} from '../../../validators.js';
    import {parameter, network, store} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import RalColor from "../../parts/RalColor.svelte";
    import DekoRalColor from "../../parts/DekoRalColor.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;
    const user = store('credential', 'getAuth');
    export let calc;
    export let options;


    // Настройки для 30 Владимир Ярославль
    if (APP_TYPE === 'axis-one' && parseInt($user.idSklad) === 30) {
        options = {
            ...options,
            polotno: {
                'Стандарт': 'Стандарт',
                'Антикошка Pet Screen':'Антикошка Pet Screen',
                'Антикошка лайт': 'Антикошка лайт',
                'Антимошка Micro Mesh': 'Антимошка Micro Mesh',
                'Антипыльца противоаллергенная': 'Антипыльца противоаллергенная',
                'Maxi Vision': 'Maxi Vision',
                'Diamond Steel нерж. сталь': 'Diamond Steel нерж. сталь',

            },
            bezlitegribok: true

        }
    }
    // Настройки для 34 Сергей Москит Астрахань
    if (APP_TYPE === 'axis-one' && parseInt($user.idSklad) === 34) {
        options = {
            ...options,
            polotno: {
                'Стандарт': 'Стандарт',
                'Антикошка Pet Screen':'Антикошка Pet Screen',
                'Антимошка Micro Mesh': 'Антимошка Micro Mesh',

            },
            bezlitegribok: false
        }
    }

    const polotno = options.polotno || {
        'Сетка москитная, стандарт': 'Стандарт',
        'Сетка москитная, Максимальный обзор': 'Максимальный обзор',
        'Сетка москитная, PPE': 'PPE',
        'Сетка москитная, АнтиМОШКА':'АнтиМОШКА',
        'Сетка москитная, Антикошка серебро': 'Антикошка серебро',
        'Сетка москитная, алюминиевая':'Алюминиевая',
        'Сетка москитная, антикошка белое':'Антикошка белое',
        'Сетка москитная, антикошка черное': 'Антикошка черное',
        'Сетка москитная, гипоаллергенная':'Гипоаллергенная',
        'Наносетка': 'Наносетка',
        'Оконный фильтр Оберег':'Оконный фильтр Оберег',
        'Сетка москитная, нержавейка':'Нержавейка',
    }

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let title = item.title.split(' ', 3);

            width.set(title[1].split('x')[0]);
            height.set(title[1].split('x')[1]);
            ind1 = item.title.includes('без перемычки') ? 'Нет' : 'Есть';
            ind2.set(title[2]);
            ind3 = Object.keys(polotno).find((el) => item.title.toLowerCase().includes(el.toLowerCase()));
            ind4 = item.title.includes('шнур-грибок') ? 'Шнур-грибок МС' : 'Шнур фиксирующий';
            ind5 = item.title.includes('Лайт') ? 'Профиль МС Вставной Лайт' : 'Профиль МС Вставной';
            ind6 = item.title.includes('пласт.угол') ? 'пластиковый' : 'вставная';
            count.set(+item.quantity);
            comment.set(item.comment);

            fetchData = await fetch($ind2);
            change();
        }
    };

    const color = options.color || {
        'Белый':'Белый',
        'Коричневый(RAL8017)':'Коричневый(RAL8017)',
        'Антрацит':'Антрацит',
        'Цветной':'Цветной',
    }

    const uplot = options.uplot || {
        'Шнур фиксирующий':'Шнур',
        'Шнур-грибок МС':'Грибок',

    }

    const fetch = async (color = 'Белый') => {
        let result = await network.fetch_data('Вставная', '', color);
        let options = await network.fetch_ind('Вставная');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options,
            result,
        }
    }

    let
        width = parameter('width', '800'),
        height = parameter('height', '1500'),
        ind1 = 'Есть', // перемычка
        ind2 = parameter('color', Object.values(color).shift()), // цвет
        ind3 = Object.keys(polotno).shift(), // полотно
        ind4 = 'Шнур фиксирующий', // уплотнитель (шнур)
        ind5 = 'Профиль МС Вставной Лайт', // профиль (вставной и лайт)
        ind6 = 'вставная', // уголок

        // другое
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch($ind2);
    let
        montage_item,
        montage_price = 1;

    const changeInd2 = () => {fetchData = fetch($ind2)};
    const changeHeight = _.debounce(() => {
        if ($height > 1400 && ind1 !== 'Есть') {
            ind1 = 'Есть';
            toastbox('toast-ind1', 3000);
        }
    }, 1000);

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;

        let
            quantity = +$count,

            w = +$width,
            h = +$height,
            packing_items = []
        ;

        let result = {
            type: 'вставная',
            name: 'Вставная',
            subname: [
                w + 'x' + h, ' ',
                $ind2, ' ', ind3, ' ',
                ind1 === 'Нет' ? 'без перемычки' : 'с перемычкой',
                ind5 === 'Профиль МС Вставной Лайт' ? ', Лайт' : '',
                ind4 === 'Шнур-грибок МС' ? ', шнур-грибок' : '',
                ind6 === 'пластиковый' ? ', пласт.угол' : ', мет.угол',
            ].join(''),
            title: [
                'Вставная', ' ', w + 'x' + h, ' ',
                $ind2, ' ', ind3, ' ',
                ind1 === 'Нет' ? 'без перемычки' : 'с перемычкой',
                ind5 === 'Профиль МС Вставной Лайт' ? ', Лайт' : '',
                ind4 === 'Шнур-грибок МС' ? ', шнур-грибок' : '',
                ind6 === 'пластиковый' ? ', пласт.угол' : ', мет.угол',
            ].join(''),
            params: {
                 ind1: [
                     ind1 === 'Нет' ? 'без перемычки' : 'с перемычкой',
                     ind5 === 'Профиль МС Вставной Лайт' ? ', Лайт' : '',
                     ind4 === 'Шнур-грибок МС' ? ', шнур-грибок' : '',
                     ind6 === 'пластиковый' ? ', пласт.угол' : ', мет.угол',
                 ].join(''),
                ind2: $ind2,
                ind3: ind3,
                ind4: $width,
                ind5: $height,
            },
            price: {rozn: 0, opt: 0, sebest: 0,},
            quantity,
            maxDay: 0,
            materials: {},
            comment: $comment,
            vStrukture: 11,
        };

        _.forEach(data.result, function(item) {
            let name = item.name.toLowerCase();

            let price = {rozn: 0, opt: 0, sebest: 0}
            let kolvo = 0;

            if (
                name.includes('профиль мс вставной') ||
                name.includes('профиль мс вставной лайт') ||
                name.includes('шнур-грибок мс') ||
                name.includes('шнур фиксирующий')
            ) {

                        if (APP_TYPE === 'plisse-ltd') {

                            if (   item.name.includes(ind4) || item.name == ind5 +' ' + $ind2  ) {

                                if (ind6 !== 'пластиковый') {
                                        kolvo = (((w + 17) * 2 + (h + 15) * 2) / 1000).toFixed(3);
                                } else {
                                    kolvo = (((w - 43) * 2 + (h - 48) * 2) / 1000).toFixed(3);
                                }
                            }

                        } else {

                            if (   item.name.includes(ind4) || item.name == ind5  ) {

                                if (ind6 !== 'пластиковый') {
                                     kolvo = (((w + 17) * 2 + (h + 12) * 2) / 1000).toFixed(3);

                                } else {
                                    kolvo = (((w - 43) * 2 + (h - 48) * 2) / 1000).toFixed(3);
                                }
                            }
                        }

            }

            if (name.includes('угол соединительный мс вставная') || name.includes('угол для вставной лайт пластиковый')) {
                if (name.includes(ind6)) {
                    kolvo = (4).toFixed(3);
                }
            }

            if (name.includes('перемычка мс')) {
                if (ind1 === 'Есть') {
                    if (APP_TYPE === 'plisse-ltd') {
                        if (ind6 !== 'пластиковый') {
                            kolvo = ((w + 17 - 61) / 1000).toFixed(3);
                        } else {
                            kolvo = ((w - 43 + 2) / 1000).toFixed(3);
                        }
                    } else {
                        kolvo = ((w - 41) / 1000).toFixed(3);
                    }
                }
            }

            if (name.includes('крепление мс перемычки')) {
                if (ind1 === 'Есть') {
                    kolvo = (2).toFixed(3);
                }
            }

            if (name.includes('фиксатор мс вставная') || name.includes('заклеп')) {
                if (ind3.toLowerCase() !== 'наносетка' && !ind3.toLowerCase().includes('оберег')) {
                    if (APP_TYPE === 'moskitoscompany') {
                        kolvo = (4).toFixed(3);
                    }
                    else if (APP_TYPE === 'plisse-ltd') {
                        if (w >= 600 || h >= 1700) {
                            kolvo = (4).toFixed(3);
                        } else {
                            kolvo = (2).toFixed(3);
                        }
                    }


                    else {
                        if (w >= 400 || h >= 1700) {
                            kolvo = (4).toFixed(3);
                        } else {
                            kolvo = (2).toFixed(3);
                        }
                    }
                }
            }

            if (name.includes('ручка металлическая')) {
                kolvo = (1).toFixed(3);
            }

            if (
                (
                    name.includes('сетка москитная') ||
                    name === 'наносетка'||
                    name.includes('оберег')||
                    name.includes('антикошка')||
                    name.includes('нтипыльца')||
                    name.includes('micro')||
                    name.includes('vision')||
                    name.includes('нерж. сталь')
                ) && name.indexOf(ind3.toLowerCase()) >= 0
            ) {
                kolvo = (w * h / 1000000).toFixed(3);
            }

            if (name.includes('комплект креплений') && (ind3.toLowerCase() === 'наносетка' || ind3.toLowerCase().includes('оберег'))) {
                kolvo = (1).toFixed(3);
            }

            if (name.includes('работа пс')) {
                if (
                    ind3.toLowerCase().includes('антикошка') ||
                    ind3.toLowerCase().includes('аллергенная') ||
                    ind3.toLowerCase().includes('оберег') ||
                    ind3.toLowerCase().includes('наносетка')||
                    ind3.toLowerCase().includes('нерж. сталь')
                ) {
                    kolvo = (1).toFixed(3);
                }
            }
            else if (name.includes('работа')) {
                if (
                    ind3.toLowerCase().includes('стандарт') ||
                    ind3.toLowerCase().includes('ppe') ||
                    ind3.toLowerCase().includes('антимошка') ||
                    ind3.toLowerCase().includes('максимальный обзор') ||
                    ind3.toLowerCase().includes('Maxi Vision'.toLowerCase()) ||
                    ind3.toLowerCase().includes('нет')
                ) {
                    kolvo = (1).toFixed(3);
                }
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.maxDay = Math.max((result.maxDay ?? 0), parseInt(item.ind1) || 0);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }

            if (name.includes('монтаж')) {
                montage_item = item;
            }
            if (name.includes('упаковка')) {
                packing_items.push(item);
            }

        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);


        if (montage_item) {
            let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
            montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);
            dispatch('mounting', {item: montage_item, price: montage_price});
        }

        dispatch('packing', {items: packing_items, multiplier: w * h / 1000000 });
        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data.edIzmer["кв.м"], null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">
            {#if APP_TYPE === 'plisse-ltd'}
                {@const filename = ($ind2 === 'Белый(9016RAL)' ?
                    '1inw.jpg' : ($ind2 === 'Анодированный(коньяк)' || $ind2 === 'Коричневый(RAL8017)' || $ind2 === 'Антрацит(7016RAL)' ?
                            '2inb.jpg' : 'inc.jpg'
                    )
                )}
                <div class="col-12  text-center d-flex order-last  order-sm-first justify-content-around">
                    <img style="max-height: 250px"
                         class="img-fluid p-3"
                         src="https://iem.plisse.ltd/tradeMasterImages/plisseltd/{filename}"
                         alt="img"
                    />
                </div>
            {/if}

            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Москитное полотно</label>
                        <select class="form-control form-select" bind:value={ind3}>
                            {#each Object.entries(polotno) as [value, name]}
                                <option value="{value}">{name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет</label>
                        <select class="form-control form-select" bind:value={$ind2} on:change={() => {changeInd2(); change()}}>
                            {#each Object.entries(color) as [value, name]}
                                <option value="{value}">{name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-12">
                <div class="form-group boxed">
                     <div class="alert alert-outline-danger">
                         К расчету принимаются только размеры светового проема!
                     </div>
                </div>
            </div>

            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">250 ≥ Шир., мм ≥ { options.max && options.max.width ? options.max.width : 1300 }</label>
                        <input type="number" class="form-control" step="10" min="250" max="{ options.max && options.max.width ? options.max.width : 1300 }" bind:value={$width} use:validate_int={$width} on:wheel={(e) => { if (document.activeElement === e.target) e.preventDefault(); }}>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">250 ≥ Выс., мм ≥ { options.max && options.max.height ? options.max.height : 2400 }</label>
                        <input type="number" class="form-control" step="10" min="250" max="{ options.max && options.max.height ? options.max.height : 2400 }" bind:value={$height} use:validate_int={$height} on:change={changeHeight} on:wheel={(e) => { if (document.activeElement === e.target) e.preventDefault(); }}>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Перемычка</label>
                        <select class="form-control form-select" bind:value={ind1}>
                            <option value="Есть">Есть</option>
                            <option value="Нет">Нет</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Уголок</label>
                        <select class="form-control form-select" bind:value={ind6}>
                            <option value="вставная">Металл</option>
                            <option value="пластиковый">Пластик</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        {#if !options.bezlitegribok }
        <div class="row" >
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Уплотнитель</label>
                        <select class="form-control form-select" bind:value={ind4}>
                            {#each Object.entries(uplot) as [value, name]}
                                <option value="{value}">{name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Профиль</label>
                        <select class="form-control form-select" bind:value={ind5}>
                            <option value="Профиль МС Вставной">Премиум</option>
                            <option value="Профиль МС Вставной Лайт">Лайт</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        {/if}

        <div class="row">
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>
            <RalColor color={$ind2} bind:comment={$comment}/>
            <DekoRalColor color={$ind2} bind:comment={$comment}/>
            <div class="col-6">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <div class="input-wrapper">
                            <label class="form-label">Примечание</label>
                            <textarea class="form-control" bind:value={$comment}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/await}

<div id="toast-ind1" class="toast-box toast-top bg-danger">
    <div class="in">
        <div class="text">
            При высоте больше 1400 мм рекомендуется поставить перемычку
        </div>
    </div>
</div>
